import { createIcon } from '@chakra-ui/react';

export const SharedIconArrowForward = createIcon({
  displayName: 'SharedIconArrowForward',
  viewBox: '0 -960 960 960',
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: [
    <path
      d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"
      fill="currentColor"
    />
  ]
});
